/* RESPONSIBLE TEAM: team-inbox-management */
import ApplicationAdapter from '../application';

export default class RealtimeDashboardSettingsAdapter extends ApplicationAdapter {
  pathForType() {
    return 'monitoring/visible_fields';
  }
}
